"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToolbarOverflowLayout = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-toolbar';
var ToolbarOverflowLayout = exports.ToolbarOverflowLayout = function ToolbarOverflowLayout(_props) {
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(ToolbarOverflowLayout, _props)) : _props;
  var startIconOrBadge = props.startIconOrBadge,
    innerTextClassName = props.innerTextClassName,
    centerText = props.centerText,
    toolbarOverflowEnd = props.toolbarOverflowEnd,
    endIconOrBadge = props.endIconOrBadge,
    size = props.size,
    hasLeftIcon = props.hasLeftIcon,
    setHasLeftIcon = props.setHasLeftIcon,
    hasRightIcon = props.hasRightIcon,
    setHasRightIcon = props.setHasRightIcon;
  var classnames = _bind.default.bind(_Toolbar.default);
  var iconCtrClasses = classnames("".concat(CSS_BLOCK, "__overflow-layout-icon-ctr"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__overflow-layout-icon-ctr--md"), size === 'md'));
  var hasLeftRightClasses = classnames("".concat(CSS_BLOCK, "__overflow-layout-ctr-left-right"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__overflow-layout-ctr-left-right--md"), size === 'md'));
  var hasLeftOnlyClasses = classnames("".concat(CSS_BLOCK, "__overflow-layout-ctr-left"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__overflow-layout-ctr-left--md"), size === 'md'));
  var hasRightOnlyClasses = classnames("".concat(CSS_BLOCK, "__overflow-layout-ctr-right"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__overflow-layout-ctr-right--md"), size === 'md'));
  var hasNoLeftRightClasses = classnames("".concat(CSS_BLOCK, "__overflow-layout-ctr"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__overflow-layout-ctr--md"), size === 'md'));
  var containerClasses = hasLeftRightClasses;
  if (hasLeftIcon && !hasRightIcon) {
    containerClasses = hasLeftOnlyClasses;
  } else if (!hasLeftIcon && hasRightIcon) {
    containerClasses = hasRightOnlyClasses;
  } else if (!hasLeftIcon && !hasRightIcon) {
    containerClasses = hasNoLeftRightClasses;
  }
  (0, _react.useEffect)(function () {
    if (!centerText) {
      return;
    }
    if (startIconOrBadge) {
      setHasLeftIcon === null || setHasLeftIcon === void 0 || setHasLeftIcon(true);
    }
    if (toolbarOverflowEnd || endIconOrBadge) {
      setHasRightIcon === null || setHasRightIcon === void 0 || setHasRightIcon(true);
    }
  }, [centerText, hasLeftIcon, hasRightIcon, startIconOrBadge, toolbarOverflowEnd, endIconOrBadge, setHasLeftIcon, setHasRightIcon]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, hasLeftIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: iconCtrClasses
  }, startIconOrBadge), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(_constants.CSS_PREFIX, innerTextClassName, "".concat(CSS_BLOCK, "__overflow-layout-text"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__overflow-layout-text--md"), size === 'md'))
  }, centerText), hasRightIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: iconCtrClasses
  }, toolbarOverflowEnd || endIconOrBadge));
};
ToolbarOverflowLayout.displayName = 'ToolbarOverflowLayout';
ToolbarOverflowLayout.propTypes = {
  startIconOrBadge: _propTypes.default.node,
  innerTextClassName: _propTypes.default.string,
  size: _propTypes.default.string,
  centerText: _propTypes.default.node,
  toolbarOverflowEnd: _propTypes.default.node,
  endIconOrBadge: _propTypes.default.node,
  hasLeftIcon: _propTypes.default.bool,
  setHasLeftIcon: _propTypes.default.func,
  hasRightIcon: _propTypes.default.bool,
  setHasRightIcon: _propTypes.default.func
};
var _default = exports.default = ToolbarOverflowLayout;